import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './SvgIcon.scss';

interface IOwnProps {
  icon: 'minus' | 'plus' | 'bag' | 'lock' | 'checkMark' | 'error' | 'success' | 'arrowLeft' | 'arrowRight' | 'information';
}
const SvgIcon: React.SFC<IOwnProps> = (props) => {
  const { icon } = props;
  // @ts-ignore
  const iconClassNames = cx({
    [Styles.icon]: true,
    [Styles[icon]]: icon,
  });

  return (
    <span className={iconClassNames} />
  );
};

export default SvgIcon;
